import gql from 'graphql-tag'

export const UPDATE_VENUE_AVAILABILITY = gql`
  mutation updateVenueAvailability(
    $eventId: ID!
    $seats: [String!]!
    $state: String!
    $organizationSlug: String!
    $venueId: ID!
  ) {
    updateVenueAvailability(
      eventId: $eventId
      seats: $seats
      state: $state
      venueId: $venueId
      organizationSlug: $organizationSlug
    ) {
      eventId
      availability
    }
  }
`
export const RESET_VENUE_AVAILABILITY = gql`
  mutation resetVenueAvailability($eventId: ID!, $organizationSlug: String!) {
    resetVenueAvailability(eventId: $eventId, organizationSlug: $organizationSlug)
  }
`
export const GET_VENUE_AVAILABILITY = gql`
  query getVenueAvailability($eventId: ID!) {
    getVenueAvailability(eventId: $eventId) {
      eventId
      availability
    }
  }
`
